<template>
  <v-select
    id="group-solution-select"
    v-model="filter.grupoSolucaoId"
    item-text="nome"
    item-name="grupoSolucaoId"
    item-value="grupoSolucaoId"
    :items="gruopSolutions"
    label="Grupo de Solução"
    placeholder="Grupo de Solução"
    clearable
    @change="$emit('changeGroupSolution')"
  >
    <template slot="no-data"> Nenhum Grupo de Solução Retornado </template>
  </v-select>
</template>

<script>
import { groupSolutionAPI } from "../API/GroupSolutionAPI";

export default {
  name: "AppGroupSolutionCombobox",
  props: ["filter", "reload"],
  mounted() {
    this.loadGroupSolution();
  },
  methods: {
    loadGroupSolution() {
      groupSolutionAPI
        .list()
        .then((resp) => {
          this.gruopSolutions = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      gruopSolutions: [],
    };
  },
  watch: {
    reload(value) {
      this.loadGroupSolution();
    },
  },
};
</script>
